import { useParams } from "react-router";
import CoreDeviceReportedState from "@gf-core/widgets/widgets/CoreDeviceReportedState";

export default function ReportedStateTab() {
  const { installationId, deviceId } = useParams();

  if (!installationId || !deviceId) return null;

  return (
    <CoreDeviceReportedState
      id={`device-reported-state-${deviceId}`}
      installationId={installationId}
      deviceTwinId={deviceId}
      inlinePadding={0}
      listConfiguration={{
        pageSize: 20,
      }}
    />
  );
}
